import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskWeight(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={(e) => {
      const enteredValue = e.target.value;
       if (enteredValue && enteredValue.endsWith("lbs")) {
          const updatedValue = enteredValue.replace("lbs", "pounds");
          props.onChange({
            target: {
              value: updatedValue,
            },
          });
        }
      }}
      mask="999 lbs"
      maskChar=" "
      spellCheck={false}
    />
  );
}

InputMaskWeight.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskWeight.js